import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useGetConceptGroupsForCustomCharacteristicsQuery } from './conceptGroupsApiSlice';

export interface UseConceptGroupsForCustomCharacteristicsOptions {
  cohortProfileId?: string;
  domain?: string;
}

export const useConceptGroupsForCustomCharacteristics = () => {
  const { projectId } = useParams();
  const [queryParams, setQueryParams] =
    useState<UseConceptGroupsForCustomCharacteristicsOptions | null>(null);
  const [shouldFetch, setShouldFetch] = useState(false);

  const {
    data: conceptGroupsResponse,
    isLoading,
    isFetching,
    error: conceptGroupsError,
  } = useGetConceptGroupsForCustomCharacteristicsQuery(
    {
      urlParams: projectId ? `projectId=${projectId}` : '',
      cohortProfileId: queryParams?.cohortProfileId,
      domain: queryParams?.domain,
    },
    {
      skip: !shouldFetch || !queryParams,
    }
  );

  const fetchConceptGroups = useCallback(
    (options: UseConceptGroupsForCustomCharacteristicsOptions) => {
      // Always set new params and trigger fetch
      setQueryParams(options);
      setShouldFetch(true);
    },
    []
  );

  const reset = useCallback(() => {
    setQueryParams(null);
    setShouldFetch(false);
  }, []);

  return {
    conceptGroups: conceptGroupsResponse?.data || [],
    isLoading: isLoading || isFetching,
    error: conceptGroupsError,
    fetchConceptGroups,
    reset,
  };
};
